import React from 'react';
import { observer, inject } from 'mobx-react';
import App from './App';
import 'moment/locale/zh-cn';
import RootStore from './store/RootStore';

interface IMainProps {
  rootStore?: RootStore;
}

@inject('rootStore')
@observer
export default class Main extends React.Component<IMainProps, any> {
  componentDidMount() {
    this.props.rootStore!.localeStore.loadLocales();
  }
  render() {
    return this.props.rootStore!.localeStore.initDone ? (
      <React.Fragment>
        <App />
        {window.isweixin ? (
          <style>{`body img { -webkit-touch-callout: none; }`}</style>
        ) : null}
      </React.Fragment>
    ) : null;
  }
}
